import React, {useEffect, useState} from 'react';
import ApiService from './api/ApiService';
import {Box, Container, Divider, Link, Typography} from "@mui/material";
import {renderDocs} from "./utils";
import {useStore} from "./store";


const Training = () => {
    const {settings, setSettings} = useStore();
    const [docs, setDocs] = useState([]);
    const admissionSteps = [
        {
            title: 'Собеседование',
            items: [
                'по математике (алгебре);',
                'по русскому языку;',
                'с психологом.',
            ],
            goal: 'Цель: определить уровень академических знаний и индивидуальные потребности каждого ребенка.',
        },
        {
            title: 'Пробные дни',
            description: '3–5 дней после успешного прохождения собеседования.',
            goal: 'Цель: для ребенка и его родителей познакомиться со школой и её ценностями, а для педагогов понять, как ребенок взаимодействует со взрослыми и ровесниками.',
        },
    ];

    const tuition = [
        {
            title: 'Начальная школа (1–4 классы)',
            price: '313 500 руб. в год',
            details: 'Школа полного дня. В стоимость включены учебные занятия, выполнение домашних заданий в формате самоподготовки, внеурочная деятельность, кружки, групповые занятия с логопедом и педагогом-психологом. Питание оплачивается дополнительно.',
        },
        {
            title: 'Основная школа (5 класс)',
            price: '301 000 руб. в год',
            details: 'В стоимость включены учебные занятия, выполнение домашних заданий в формате самоподготовки и внеурочная деятельность. Дополнительно оплачиваются питание, творческие и спортивные кружки.',
        },
        {
            title: 'Основная школа (6–8 классы)',
            price: '301 000 руб. в год',
            details: 'В стоимость включены учебные занятия и внеурочная деятельность. Дополнительно оплачиваются питание, группа продлённого дня, а также творческие и спортивные кружки.',
        },
        {
            title: 'Основная школа (9 класс)',
            price: '311 000 руб. в год',
            details: 'В стоимость включены учебные занятия и внеурочная деятельность. Дополнительно оплачиваются питание, группа продлённого дня, а также творческие и спортивные кружки.',
        },
        {
            title: 'Средняя школа (10–11 классы)',
            price: '323 500 руб. в год',
            details: 'В стоимость включены учебные занятия и внеурочная деятельность. Дополнительно оплачиваются питание, группа продлённого дня, а также творческие и спортивные кружки.',
        },
    ];
    useEffect(() => {
        ApiService.getDocs('kim')
            .then(response => {
                setDocs(response.docs)
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <Container>
            <Box mt={6} mb={5}>
                <Typography variant="h6" gutterBottom fontWeight={'bold'}>
                    В нашей школе обучаются дети с 1 по 11 класс.
                </Typography>
            </Box>

            <Box mt={6} mb={5}>
                <Typography variant="h6" gutterBottom fontWeight={'bold'}>
                    Порядок поступления
                </Typography>
                <Typography variant="h6" paragraph>
                    Поступление в школу состоит из двух этапов:
                </Typography>
                <Box component="ol" sx={{pl: 3, m: 0}}>
                    <Box component="li" sx={{mb: 3}}>
                        <Typography variant="h6" paragraph sx={{mb: 0.5}}>
                            <strong>Собеседование:</strong>
                        </Typography>
                        <Box component="ul" sx={{pl: 3, m: 0}}>
                            <Box component="li" sx={{mb: 0.5}}>
                                <Typography variant="h6" paragraph sx={{mb: 0}}>
                                    по математике (алгебре);
                                </Typography>
                            </Box>
                            <Box component="li" sx={{mb: 0.5}}>
                                <Typography variant="h6" paragraph sx={{mb: 0}}>
                                    по русскому языку;
                                </Typography>
                            </Box>
                            <Box component="li" sx={{mb: 0.5}}>
                                <Typography variant="h6" paragraph sx={{mb: 0}}>
                                    с психологом.
                                </Typography>
                            </Box>
                        </Box>
                        <Typography variant="h6" paragraph sx={{mb: 2}}>
                            Цель: определить уровень академических знаний и индивидуальные потребности каждого ребенка.
                        </Typography>
                        <Typography variant="h6" paragraph sx={{mb: 2}}>
                            Ознакомиться с примерными работами по математике (алгебре) и русскому языку можно в разделе
                            {' '}
                            <Link href="#documents">«Примерные контрольно-измерительные материалы»</Link>
                            {' '} (смотреть ниже). Примерными контрольно-измерительными материалами могут быть также и
                            {' '}
                            <Link href="https://fioco.ru/obraztsi_i_opisaniya_vpr" target="_blank" rel="noreferrer">
                                всероссийские проверочные работы
                            </Link>.
                        </Typography>
                    </Box>

                    <Box component="li" sx={{mb: 0}}>
                        <Typography variant="h6" paragraph sx={{mb: 0.5}}>
                            <strong>Пробные дни (3–5 дней) после успешного прохождения собеседования.</strong>
                        </Typography>
                        <Typography variant="h6" paragraph sx={{mb: 2}}>
                            Цель: для ребенка и его родителей познакомиться со школой и её ценностями, а для педагогов понять, как ребенок взаимодействует со взрослыми и ровесниками.
                        </Typography>
                    </Box>
                </Box>
                <Typography variant="h6" paragraph>
                    После успешного прохождения всех этапов выносится финальное решение о зачислении ребенка в школу.
                </Typography>
            </Box>

            <Divider  />

            <Box mt={6} mb={5}>
                <Typography variant="h6" gutterBottom fontWeight={'bold'}>
                    Стоимость обучения
                </Typography>
                {tuition.map((item) => (
                    <Box key={item.title} mb={3}>
                        <Typography variant="h6" fontWeight={700} gutterBottom>
                            {item.title} – {item.price}
                        </Typography>
                        <Typography variant="h6" paragraph sx={{mb: 0}}>
                            {item.details}
                        </Typography>
                    </Box>
                ))}
            </Box>

            <Divider />

            <Box mt={6} mb={5}>
                <Typography variant="h6" gutterBottom fontWeight={'bold'}>
                    Как подать заявку
                </Typography>
                <Typography variant="h6" paragraph>
                    Связаться с нами для подачи заявки можно по электронной почте
                    {' '}
                    <Link href={`mailto:${settings.email}`}>{settings.email}</Link>
                    {' '}или по телефону {' '}
                    <Link href={`tel:${settings.phone}`}>{settings.phone}</Link>
                </Typography>
                <Typography variant="h6">
                    Если в данный момент в классе нет свободных мест, администратор предложит записаться в резерв.
                    Как только появится место, мы свяжемся с вами и пригласим на собеседование.
                </Typography>
            </Box>
            <Divider id="documents" />
            <Box mt={6} mb={4}>
                {renderDocs(docs)}
            </Box>
        </Container>
    );
};

export default Training;
